import * as React from 'react';
import customSolarIconWrapper from '../../../custom-icons';

// Placed on the shared 240x240 doodle frame: stack a body, eyes, mouth and accessory to compose a doodle
const DoodleAccessoryHat = customSolarIconWrapper(<g transform="translate(12 28)">
	<path d="M74 66.6471C71.3333 39.0392 76.6667 23.9804 90 21.4706C102 29 114 29 126 21.4706C139.333 23.9804 144.667 39.0392 142 66.6471H74Z" fill="#202020" />
	<path d="M18 66.6471C78 57.8627 138 55.9804 198 61C138 72.2941 78 74.1765 18 66.6471Z" fill="#202020" />
	<path d="M74 66.6471C71.3333 39.0392 76.6667 23.9804 90 21.4706C102 29 114 29 126 21.4706C139.333 23.9804 144.667 39.0392 142 66.6471" stroke="#202020" strokeWidth="11" strokeLinecap="round" strokeLinejoin="round" />
	<path d="M18 66.6471C78 57.8627 138 55.9804 198 61C138 72.2941 78 74.1765 18 66.6471Z" stroke="#202020" strokeWidth="11" strokeLinecap="round" strokeLinejoin="round" />
	<path d="M76 61C97.3333 64.7647 118.667 64.7647 140 61" stroke="#202020" strokeWidth="9" strokeLinecap="round" strokeLinejoin="round" />
</g>, { viewBox: '0 0 240 240' });

export default DoodleAccessoryHat;
